import script from "./QrCode.vue?vue&type=script&setup=true&lang=js"
export * from "./QrCode.vue?vue&type=script&setup=true&lang=js"

import "./QrCode.vue?vue&type=style&index=0&id=15ff67d0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15ff67d0"]])

export default __exports__